import { render, staticRenderFns } from "./KnowledgeSelectedSideBar.vue?vue&type=template&id=747b1ddb&"
import script from "./KnowledgeSelectedSideBar.vue?vue&type=script&lang=js&"
export * from "./KnowledgeSelectedSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports